import React from "react";
import MUIBox from "@material-ui/core/Box";
import { BoxProps } from "@material-ui/core/Box/Box";

const Box = (props: BoxProps) => {
	return <MUIBox {...props} />;
};

export { Box };
